import { render, staticRenderFns } from "./WisdomParam.vue?vue&type=template&id=b65c0fb0"
import script from "./WisdomParam.vue?vue&type=script&lang=js"
export * from "./WisdomParam.vue?vue&type=script&lang=js"
import style0 from "./WisdomParam.vue?vue&type=style&index=0&id=b65c0fb0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports